import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';
import {
  FETCH_WORK_INSIGHTS_BRANDAFFINITY,
  FETCH_WORK_INSIGHTS_BRANDAFFINITY_ERROR,
  SET_WORK_INSIGHTS_BRANDAFFINITY,
} from '../../constants';

const workInsightsBrandAffinity = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_WORK_INSIGHTS_BRANDAFFINITY),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/work/brand-affinity?${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_WORK_INSIGHTS_BRANDAFFINITY,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_WORK_INSIGHTS_BRANDAFFINITY_ERROR,
            error,
          })
        )
      )
    )
  );

export default workInsightsBrandAffinity;
